import Splide from '@splidejs/splide';

export function initCaseStudiesReviewsSlider() {
  const caseStudiesReviewsSliderEl = document.querySelector(
    '[data-pro-single-family-case-studies-word-of-mouth-reviews-slider]'
  );

  new Splide(caseStudiesReviewsSliderEl, {
    type: 'slide',
    lazyLoad: true,
    perPage: 1,
    perMove: 1,
    speed: 500,
    rewind: true,
    arrows: false,
    pagination: true,
    classes: {
      pagination:
        'splide__pagination pro-single-family-case-studies-word-of-mouth__reviews-slider-pagination',
      page: 'splide__pagination__page pro-single-family-case-studies-word-of-mouth__reviews-slider-pagination-btn',
    },
  }).mount();
}
